import React from 'react';
import { Card, Form, Select, Input, Row, Col, Space, Button } from 'antd';
import { PlusOutlined, MinusCircleOutlined } from '@ant-design/icons';
import { FormInstance } from 'antd/es/form';

const { Option } = Select;

interface IssuesProps {
  form: FormInstance;
}

const Issues: React.FC<IssuesProps> = ({ form }) => {
  const categoryOptions = [
    'All',
    'Benefits/Pay/Privilege',
    'Equipment/Supplies',
    'Physical Abuse',
    'Verbal Abuse',
    'Other'
  ];

  return (
    <Card title="Issues - What was done by the accused? (select up to 3 items)" style={{ marginBottom: 16 }}>
      <Form.List name={['issues_info', 'issues']}>
        {(fields, { add, remove }) => (
          <>
            {fields.map(({ key, name, ...restField }) => (
              <Card key={key} type="inner" style={{ marginBottom: 16 }}>
                <Row gutter={16}>
                  <Col span={8}>
                    <Form.Item
                      {...restField}
                      name={[name, 'category']}
                      label="Category:"
                    >
                      <Select placeholder="Select category">
                        {categoryOptions.map(option => (
                          <Option key={option} value={option}>{option}</Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col span={8}>
                    <Form.Item
                      {...restField}
                      name={[name, 'issue']}
                      label="Issue:"
                    >
                      <Input placeholder="Enter issue description" />
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item
                      {...restField}
                      name={[name, 'date']}
                      label="Date:"
                    >
                      <Input placeholder="MMDDYY" />
                    </Form.Item>
                  </Col>
                  <Col span={2}>
                    <Form.Item label=" ">
                      <Button
                        type="text"
                        danger
                        icon={<MinusCircleOutlined />}
                        onClick={() => remove(name)}
                      />
                    </Form.Item>
                  </Col>
                </Row>
              </Card>
            ))}
            {fields.length < 3 && (
              <Form.Item>
                <Button type="dashed" onClick={() => add()} block icon={<PlusOutlined />}>
                  Add Issue
                </Button>
              </Form.Item>
            )}
          </>
        )}
      </Form.List>
    </Card>
  );
};

export default Issues;

